'use client'

import ThemeContainer from '@/app/components/theme-container'
import { ArrowPathIcon } from '@heroicons/react/24/solid'
import Link from 'next/link'

export default function TranslateError() {
    return (
        <ThemeContainer>
            <div className="flex h-full items-center justify-center">
                <div className="text-center">
                    <img
                        src={'/hippos/standing.svg'}
                        alt="hippo"
                        height={20}
                        width={55}
                        className="mx-auto animate-spin"
                    />
                    <h1>There was an error!!!</h1>
                    <p>
                        Please refresh the page{' '}
                        <Link href="/translate">
                            <ArrowPathIcon className="inline-block h-6 w-6" />
                        </Link>
                    </p>
                </div>
            </div>
        </ThemeContainer>
    )
}
